import { RefreshCwIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// Unified refresh button: spins its icon while `spinning`.
export const RefreshButton = ({
  spinning,
  onClick,
  className,
}: {
  spinning?: boolean;
  onClick?: () => void;
  className?: string;
}) => (
  <Button
    type="button"
    variant="outline"
    size="sm"
    onClick={onClick}
    disabled={spinning}
    className={cn("h-8 gap-2", className)}
  >
    <RefreshCwIcon className={cn("h-3.5 w-3.5", spinning && "animate-spin")} />
    Refresh
  </Button>
);

export default RefreshButton;
